// IMPORT REACT
import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";

// import NavBar from "./_components/Navbar/NavBar";
import NavBarDrawer from "./_components/Drawer/NavBarDrawer";
import LoadingFallback from "../components/Fallback/LoadingFallback";

import NotFound from "../pages/NotFound/NotFound";
import App from "../App";
import AuthGuard from "../components/Common/AuthGuard";
import InvestigationSampleCollectedFromList from "../pages/Investigation/InvestigationSampleCollectedFrom/InvestigationSampleCollectedFromList";
import InvestigationSampleCollectedFromSave from "../pages/Investigation/InvestigationSampleCollectedFrom/InvestigationSampleCollectedFromSave";
import NotificationTemplateSave from "../pages/NotificationTemplate/NotificationTemplateSave";
import GrowthChartItemSave from "../pages/GrowthChartItem/GrowthChartItemSave";
import GrowthChartItemList from "../pages/GrowthChartItem/GrowthChartItemList";
import HistoryTemplateList from "../pages/Template/HistoryTemplate/HistoryTemplateList";
import HistoryTemplateSave from "../pages/Template/HistoryTemplate/HistoryTemplateSave";
import DiagnosisTemplateList from "../pages/Template/DiagnosisTemplate/DiagnosisTemplateList";
import DiagnosisTemplateSave from "../pages/Template/DiagnosisTemplate/DiagnosisTemplateSave";
import ProcedureList from "../pages/Procedure/ProcedureList";
import ProcedureSave from "../pages/Procedure/ProcedureSave";
import RefHistoryDentalHistoryList from "../pages/Dental/RefHistoryDentalHistory/RefHistoryDentalHistoryList";
import RefHistoryDentalHistorySave from "../pages/Dental/RefHistoryDentalHistory/RefHistoryDentalHistorySave";

import RefOBGyExaminationBreastExaminationList from "../pages/Obstretric/BreastExamination/RefOBGyExaminationBreastExaminationList";
import RefOBGyExaminationBreastExaminationSave from "../pages/Obstretric/BreastExamination/RefOBGyExaminationBreastExaminationSave";
import RefOBGyExaminationPerVaginalExaminationList from "../pages/Obstretric/RefOBGyExaminationPerVaginalExamination/RefOBGyExaminationPerVaginalExaminationList";
import RefHistoryOBGyHistoryTypeOfSurgeryList from "../pages/ChiefComplaint/RefHistoryOBGyHistoryTypeOfSurgery/RefHistoryOBGyHistoryTypeOfSurgeryList";
import RefHistoryOBGyHistoryTypeOfSurgerySave from "../pages/ChiefComplaint/RefHistoryOBGyHistoryTypeOfSurgery/RefHistoryOBGyHistoryTypeOfSurgerySave";
import RefOBGyExaminationPerVaginalExaminationSave from "../pages/Obstretric/RefOBGyExaminationPerVaginalExamination/RefOBGyExaminationPerVaginalExaminationSave";
import RefOBGyExaminationTypeOfUSGList from "../pages/Obstretric/RefOBGyExaminationTypeOfUSG/RefOBGyExaminationTypeOfUSGList";
import RefOBGyExaminationTypeOfUSGSave from "../pages/Obstretric/RefOBGyExaminationTypeOfUSG/RefOBGyExaminationTypeOfUSGSave";
import RefOBGyExaminationFetalLiesList from "../pages/Obstretric/RefOBGyExaminationFetalLies/RefOBGyExaminationFetalLiesList";
import RefOBGyExaminationLiquorList from "../pages/Obstretric/RefOBGyExaminationLiquor/RefOBGyExaminationLiquorList";
import RefOBGyExaminationLiquorSave from "../pages/Obstretric/RefOBGyExaminationLiquor/RefOBGyExaminationLiquorSave";
import RefOBGyExaminationDopplerFindingsList from "../pages/Obstretric/RefOBGyExaminationDopplerFindings/RefOBGyExaminationDopplerFindingsList";
import RefOBGyExaminationDopplerFindingsSave from "../pages/Obstretric/RefOBGyExaminationDopplerFindings/RefOBGyExaminationDopplerFindingsSave";
import RefOBGyExaminationFetalHeartRateDescriptionList from "../pages/Obstretric/RefOBGyExaminationFetalHeartRateDescription/RefOBGyExaminationFetalHeartRateDescriptionList";
import RefOBGyExaminationFetalHeartRateDescriptionSave from "../pages/Obstretric/RefOBGyExaminationFetalHeartRateDescription/RefOBGyExaminationFetalHeartRateDescriptionSave";
import RefOBGyExaminationUterusShapeList from "../pages/Obstretric/RefOBGyExaminationUterusShape/RefOBGyExaminationUterusShapeList";
import RefOBGyExaminationUterusShapeSave from "../pages/Obstretric/RefOBGyExaminationUterusShape/RefOBGyExaminationUterusShapeSave";
import RefOBGyExaminationUterusMeasurementList from "../pages/Obstretric/RefOBGyExaminationUterusMeasurement/RefOBGyExaminationUterusMeasurementList";
import RefOBGyExaminationUterusMeasurementSave from "../pages/Obstretric/RefOBGyExaminationUterusMeasurement/RefOBGyExaminationUterusMeasurementSave";
import RefOBGyExaminationOvaryDescriptionSave from "../pages/Obstretric/RefOBGyExaminationOvaryDescription/RefOBGyExaminationOvaryDescriptionSave";
import RefOBGyExaminationOvaryDescriptionList from "../pages/Obstretric/RefOBGyExaminationOvaryDescription/RefOBGyExaminationOvaryDescriptionList";

import RefHistoryOBGyHistoryOutcomeOfSurgeryList from "../pages/ChiefComplaint/RefHistoryOBGyHistoryOutcomeOfSurgery/RefHistoryOBGyHistoryOutcomeOfSurgeryList";
import RefHistoryOBGyHistoryOutcomeOfSurgerySave from "../pages/ChiefComplaint/RefHistoryOBGyHistoryOutcomeOfSurgery/RefHistoryOBGyHistoryOutcomeOfSurgerySave";
import RefHistoryOBGyHistoryDetailsOfCongenitalAnomalyList from "../pages/ChiefComplaint/RefHistoryOBGyHistoryDetailsOfCongenitalAnomaly/RefHistoryOBGyHistoryDetailsOfCongenitalAnomalyList";
import RefHistoryOBGyHistoryDetailsOfCongenitalAnomalySave from "../pages/ChiefComplaint/RefHistoryOBGyHistoryDetailsOfCongenitalAnomaly/RefHistoryOBGyHistoryDetailsOfCongenitalAnomalySave";
import RefHistoryOBGyHistoryTypeOfARTList from "../pages/ChiefComplaint/RefHistoryOBGyHistoryTypeOfART/RefHistoryOBGyHistoryTypeOfARTList";
import RefHistoryOBGyHistoryTypeOfARTSave from "../pages/ChiefComplaint/RefHistoryOBGyHistoryTypeOfART/RefHistoryOBGyHistoryTypeOfARTSave";
import RefHistoryOBGyHistoryEventsDuringARTList from "../pages/ChiefComplaint/RefHistoryOBGyHistoryEventsDuringART/RefHistoryOBGyHistoryEventsDuringARTList";
import RefHistoryOBGyHistoryEventsDuringARTSave from "../pages/ChiefComplaint/RefHistoryOBGyHistoryEventsDuringART/RefHistoryOBGyHistoryEventsDuringARTSave";
import RefHistoryOBGyHistoryOutcomeOfARTList from "../pages/ChiefComplaint/RefHistoryOBGyHistoryOutcomeOfART/RefHistoryOBGyHistoryOutcomeOfARTList";
import RefHistoryOBGyHistoryOutcomeOfARTSave from "../pages/ChiefComplaint/RefHistoryOBGyHistoryOutcomeOfART/RefHistoryOBGyHistoryOutcomeOfARTSave";
import RefHistoryOBGyHistoryMenstrualDurationList from "../pages/ChiefComplaint/RefHistoryOBGyHistoryMenstrualDuration/RefHistoryOBGyHistoryMenstrualDurationList";
import RefHistoryOBGyHistoryMenstrualDurationSave from "../pages/ChiefComplaint/RefHistoryOBGyHistoryMenstrualDuration/RefHistoryOBGyHistoryMenstrualDurationSave";
import RefHistoryOBGyHistoryMenstrualNatureList from "../pages/ChiefComplaint/RefHistoryOBGyHistoryMenstrualNature/RefHistoryOBGyHistoryMenstrualNatureList";
import RefHistoryOBGyHistoryMenstrualNatureSave from "../pages/ChiefComplaint/RefHistoryOBGyHistoryMenstrualNature/RefHistoryOBGyHistoryMenstrualNatureSave";

import ReferBook from "../pages/ReferBookEntry/ReferBook";
import ReferBookPreview from "../pages/ReferBookEntry/ReferBookPreview";
import ReferBookThankYou from "../pages/ReferBookEntry/ReferBookThankYou";
import ReferBookEntry from "../pages/ReferBookEntry/ReferBookEntry";
import ReasonForReferenceList from "../pages/ReasonForReference/ReasonForReferenceList";
import ReasonForReferenceSave from "../pages/ReasonForReference/ReasonForReferenceSave";
import ReferBookEntryList from "../pages/ReferBookEntry/ReferBookEntryList";
import ReferBookEntryDetails from "../pages/ReferBookEntry/ReferBookEntryDetails";
import ActivityList from "../pages/ReferBookEntry/ActivityList";
import RolesSave from "../pages/Team/UserGroup/RolesSave";
import ReferBookReport from "../pages/ReferBookEntry/ReferBookReport";
import PrescriptionReport from "../pages/Report/Priscription/PrescriptionReport";
import CertificateReport from "../pages/OPD/Certificates/CertificateReport";
import GrowthChartReport from "../components/Chart/GrowthChartReport";
import FullPrescriptionReport from "../pages/Report/FullPrescriptionReport";

import BillingReport from "../pages/Report/BillingReport";
import RefMemberProcedureExaminationList from "../pages/Dental/RefMemberProcedureExamination/RefMemberProcedureExaminationList";
import RefMemberProcedureExaminationSave from "../pages/Dental/RefMemberProcedureExamination/RefMemberProcedureExaminationSave";
import GeneralProcedureList from "../pages/Dental/GeneralProcedure/GeneralProcedureList";
import GeneralProcedureSave from "../pages/Dental/GeneralProcedure/GeneralProcedureSave";
import SpecialMedicalConditionMasterSave from "../pages/SpecialMedicalCondition/SpecialMedicalConditionMasterSave";
import SpecialMedicalConditionMasterList from "../pages/SpecialMedicalCondition/SpecialMedicalConditionMasterList";
import Form3CForm25Report from "../pages/Report/Form3CForm25Report";
import TermsAndConditions from "../pages/TermsAndConditions/TermsAndConditions";
import PrivacyAndPolicy from "../pages/PrivacyAndPolicy/PrivacyAndPolicy";
import ProcedurePlannedInProcessReport from "../pages/Report/ProcedureStatusReport";
import ProcedureStatusReport from "../pages/Report/ProcedureStatusReport";
import ReportParameterList from "../pages/Settings/Configuration/ReportParameterConfiguration/ReportParameterList";
import ReportParameterSave from "../pages/Settings/Configuration/ReportParameterConfiguration/ReportParameterSave";
import BillingConfiguration from "../pages/Settings/Configuration/BillingConfiguration/BillingConfiguration";
import OPDClinicalPreview from "../pages/OPD/OPDClinical/OPDClinicalPreview";
import OphthalVisualAcuityUnaidedDistanceVASave from "../pages/Ophthal/VisualAcuity/UnaidedDistanceVA/OphthalVisualAcuityUnaidedDistanceVASave";
import OphthalVisualAcuityUnaidedDistanceVAList from "../pages/Ophthal/VisualAcuity/UnaidedDistanceVA/OphthalVisualAcuityUnaidedDistanceVAList";
import OphthalVisualAcuityPinholeVAList from "../pages/Ophthal/VisualAcuity/PinholeVA/OphthalVisualAcuityPinholeVAList";
import OphthalVisualAcuityPinholeVASave from "../pages/Ophthal/VisualAcuity/PinholeVA/OphthalVisualAcuityPinholeVASave";
import OphthalVisualAcuityBestCorrectedVAList from "../pages/Ophthal/VisualAcuity/BestCorrectedVA(BCVA)/OphthalVisualAcuityBestCorrectedVAList";
import OphthalVisualAcuityBestCorrectedVASave from "../pages/Ophthal/VisualAcuity/BestCorrectedVA(BCVA)/OphthalVisualAcuityBestCorrectedVASave";
import OphthalVisualAcuityNearVisionList from "../pages/Ophthal/VisualAcuity/NearVision/OphthalVisualAcuityNearVisionList";
import OphthalVisualAcuityNearVisionSave from "../pages/Ophthal/VisualAcuity/NearVision/OphthalVisualAcuityNearVisionSave";
import OphthalVisualAcuityFinalVisualAcuityList from "../pages/Ophthal/VisualAcuity/FinalVisualAcuity/OphthalVisualAcuityFinalVisualAcuityList";
import OphthalVisualAcuityFinalVisualAcuitySave from "../pages/Ophthal/VisualAcuity/FinalVisualAcuity/OphthalVisualAcuityFinalVisualAcuitySave";
import OphthalRefractionDistantSphereList from "../pages/Ophthal/Refraction/Distant/OphthalRefractionDistantSphereList";
import OphthalRefractionDistantSphereSave from "../pages/Ophthal/Refraction/Distant/OphthalRefractionDistantSphereSave";
import OphthalRefractionNearSphereSave from "../pages/Ophthal/Refraction/Near(ADD)/OphthalRefractionNearSphereSave";
import OphthalRefractionNearSphereList from "../pages/Ophthal/Refraction/Near(ADD)/OphthalRefractionNearSphereList";
import OphthalRefractionCylinderSave from "../pages/Ophthal/Refraction/Distant/OphthalRefractionCylinderSave";
import OphthalRefractionCylinderList from "../pages/Ophthal/Refraction/Distant/OphthalRefractionCylinderList";
import OphthalRefractionAxisSave from "../pages/Ophthal/Refraction/Distant/OphthalRefractionAxisSave";
import OphthalRefractionAxisList from "../pages/Ophthal/Refraction/Distant/OphthalRefractionAxisList";
import OphthalRefractionDistantVisionList from "../pages/Ophthal/Refraction/Distant/OphthalRefractionDistantVisionList";
import OphthalRefractionDistantVisionSave from "../pages/Ophthal/Refraction/Distant/OphthalRefractionDistantVisionSave";
import OphthalRefractionNearVisionList from "../pages/Ophthal/Refraction/Near(ADD)/OphthalRefractionNearVisionList";
import OphthalRefractionNearVisionSave from "../pages/Ophthal/Refraction/Near(ADD)/OphthalRefractionNearVisionSave";
import OphthalOccularMotilityExtraocularMovementsList from "../pages/Ophthal/OccularMotilityandPupils/ExtraocularMovements/OphthalOccularMotilityExtraocularMovementsList";
import OphthalOccularMotilityExtraocularMovementsSave from "../pages/Ophthal/OccularMotilityandPupils/ExtraocularMovements/OphthalOccularMotilityExtraocularMovementsSave";
import OphthalOccularMotilityPupillaryReactionList from "../pages/Ophthal/OccularMotilityandPupils/PupillaryReaction/OphthalOccularMotilityPupillaryReactionList";
import OphthalOccularMotilityPupillaryReactionSave from "../pages/Ophthal/OccularMotilityandPupils/PupillaryReaction/OphthalOccularMotilityPupillaryReactionSave";
import OphthalOccularMotilityRAPDSave from "../pages/Ophthal/OccularMotilityandPupils/RelativeAfferentPupillaryDefect(RAPD)/OphthalOccularMotilityRAPDSave";
import OphthalOccularMotilityRAPDList from "../pages/Ophthal/OccularMotilityandPupils/RelativeAfferentPupillaryDefect(RAPD)/OphthalOccularMotilityRAPDList";
import OphthalOccularMotilityVFBCSave from "../pages/Ophthal/OccularMotilityandPupils/VisualFieldsByConfrontation/OphthalOccularMotilityVFBCSave";
import OphthalOccularMotilityVFBCList from "../pages/Ophthal/OccularMotilityandPupils/VisualFieldsByConfrontation/OphthalOccularMotilityVFBCList";
import OphthalSlitLampEyelidsList from "../pages/Ophthal/SlitLamp/Eyelids/OphthalSlitLampEyelidsList";
import OphthalSlitLampEyelidsSave from "../pages/Ophthal/SlitLamp/Eyelids/OphthalSlitLampEyelidsSave";
import OphthalSlitLampConjunctivaList from "../pages/Ophthal/SlitLamp/Conjunctiva/OphthalSlitLampConjunctivaList";
import OphthalSlitLampConjunctivaSave from "../pages/Ophthal/SlitLamp/Conjunctiva/OphthalSlitLampConjunctivaSave";
import OphthalSlitLampCorneaList from "../pages/Ophthal/SlitLamp/Cornea/OphthalSlitLampCorneaList";
import OphthalSlitLampCorneaSave from "../pages/Ophthal/SlitLamp/Cornea/OphthalSlitLampCorneaSave";
import OphthalSlitLampAnteriorChamberList from "../pages/Ophthal/SlitLamp/AnteriorChamber/OphthalSlitLampAnteriorChamberList";
import OphthalSlitLampAnteriorChamberSave from "../pages/Ophthal/SlitLamp/AnteriorChamber/OphthalSlitLampAnteriorChamberSave";
import OphthalSlitLampIrisList from "../pages/Ophthal/SlitLamp/Iris/OphthalSlitLampIrisList";
import OphthalSlitLampIrisSave from "../pages/Ophthal/SlitLamp/Iris/OphthalSlitLampIrisSave";
import OphthalSlitLampLensList from "../pages/Ophthal/SlitLamp/Lens/OphthalSlitLampLensList";
import OphthalSlitLampLensSave from "../pages/Ophthal/SlitLamp/Lens/OphthalSlitLampLensSave";
import OphthalPosteriorSegmentVitreousList from "../pages/Ophthal/PosteriorSegmentOrFundus/Vitreous/OphthalPosteriorSegmentVitreousList";
import OphthalPosteriorSegmentVitreousSave from "../pages/Ophthal/PosteriorSegmentOrFundus/Vitreous/OphthalPosteriorSegmentVitreousSave";
import OphthalPosteriorSegmentOpticDiscList from "../pages/Ophthal/PosteriorSegmentOrFundus/OpticDisc/OphthalPosteriorSegmentOpticDiscList";
import OphthalPosteriorSegmentOpticDiscSave from "../pages/Ophthal/PosteriorSegmentOrFundus/OpticDisc/OphthalPosteriorSegmentOpticDiscSave";
import OphthalPosteriorSegmentCupToDiscRatioList from "../pages/Ophthal/PosteriorSegmentOrFundus/CupToDiscRatio/OphthalPosteriorSegmentCupToDiscRatioList";
import OphthalPosteriorSegmentCupToDiscRatioSave from "../pages/Ophthal/PosteriorSegmentOrFundus/CupToDiscRatio/OphthalPosteriorSegmentCupToDiscRatioSave";
import OphthalPosteriorSegmentMaculaList from "../pages/Ophthal/PosteriorSegmentOrFundus/Macula/OphthalPosteriorSegmentMaculaList";
import OphthalPosteriorSegmentMaculaSave from "../pages/Ophthal/PosteriorSegmentOrFundus/Macula/OphthalPosteriorSegmentMaculaSave";
import OphthalPosteriorSegmentRetinalVesselsList from "../pages/Ophthal/PosteriorSegmentOrFundus/RetinalVessels/OphthalPosteriorSegmentRetinalVesselsList";
import OphthalPosteriorSegmentRetinalVesselsSave from "../pages/Ophthal/PosteriorSegmentOrFundus/RetinalVessels/OphthalPosteriorSegmentRetinalVesselsSave";
import OphthalPosteriorSegmentPeripheralRetinaList from "../pages/Ophthal/PosteriorSegmentOrFundus/PeripheralRetina/OphthalPosteriorSegmentPeripheralRetinaList";
import OphthalPosteriorSegmentPeripheralRetinaSave from "../pages/Ophthal/PosteriorSegmentOrFundus/PeripheralRetina/OphthalPosteriorSegmentPeripheralRetinaSave";
import OphthalIOPMeasurementMethodList from "../pages/Ophthal/IOP/MeasurementMethod/OphthalIOPMeasurementMethodList";
import OphthalIOPMeasurementMethodSave from "../pages/Ophthal/IOP/MeasurementMethod/OphthalIOPMeasurementMethodSave";

const SignInCover = React.lazy(
  () => import("../pages/SignInCover/SignInCover"),
);
const SignIn = React.lazy(() => import("../pages/SignIn/SignIn"));
const SignUp = React.lazy(() => import("../pages/SignUp/SignUp"));
const ThankYou = React.lazy(() => import("../pages/ThankYou/ThankYou"));
const Dashboard = React.lazy(() => import("../pages/Dashboard/Dashboard"));
const AbdmAbha = React.lazy(() => import("../pages/Abdm/AbdmAbha"));
const AbdmHfr = React.lazy(() => import("../pages/Abdm/AbdmHfr"));
const AbdmHpr = React.lazy(() => import("../pages/Abdm/AbdmHpr"));
const AbdmHealthRecords = React.lazy(
  () => import("../pages/Abdm/AbdmHealthRecords"),
);
const AbdmConsent = React.lazy(() => import("../pages/Abdm/AbdmConsent"));
const ClinicalAnalytics = React.lazy(
  () => import("../pages/Dashboard/ClinicalAnalytics"),
);
const DentalAnalytics = React.lazy(
  () => import("../pages/Dashboard/DentalAnalytics"),
);
const Master = React.lazy(() => import("../pages/Master/Master"));
const Templates = React.lazy(() => import("../pages/Templates/Templates"));
const Calendar = React.lazy(() => import("../pages/calendar/calendar"));

const NotificationReport = React.lazy(
  () => import("../pages/NotificationReport/NotificationReport"),
);
const ResetPassword = React.lazy(
  () => import("../pages/Resetpassword/Resetpassword"),
);

const ForgotPassword = React.lazy(
  () => import("../pages/Forgotpassword/Forgotpassword"),
);

const FetalPresentingPartList = React.lazy(
  () =>
    import("../pages/Obstretric/FetalPresentingPart/FetalPresentingPartList"),
);
const FetalPositionList = React.lazy(
  () => import("../pages/Obstretric/FetalPosition/FetalPositionList"),
);

const ManageUser = React.lazy(() => import("../pages/Team/Users/ManageUser"));
const Settings = React.lazy(() => import("../pages/Settings/Settings"));
const Help = React.lazy(() => import("../pages/Help/Help"));
const BranchList = React.lazy(() => import("../pages/Branch/BranchList"));
const BranchSave = React.lazy(() => import("../pages/Branch/BranchSave"));

const DepartmentList = React.lazy(
  () => import("../pages/Department/DepartmentList"),
);
const DepartmentSave = React.lazy(
  () => import("../pages/Department/DepartmentSave"),
);
const MedicineDoseList = React.lazy(
  () => import("../pages/Medicine/MedicineDose/MedicineDoseList"),
);
const MedicineDoseSave = React.lazy(
  () => import("../pages/Medicine/MedicineDose/MedicineDoseSave"),
);
const FollowUpMasterList = React.lazy(
  () => import("../pages/FollowUp/FollowUpMaster/FollowUpMasterList"),
);
const FollowUpMasterSave = React.lazy(
  () => import("../pages/FollowUp/FollowUpMaster/FollowUpMasterSave"),
);
const FollowUpReasonList = React.lazy(
  () => import("../pages/FollowUp/FollowUpReason/FollowUpReasonList"),
);
const FollowUpReasonSave = React.lazy(
  () => import("../pages/FollowUp/FollowUpReason/FollowUpReasonSave"),
);
const FollowUpInstructionList = React.lazy(
  () => import("../pages/FollowUp/FollowUpInstruction/FollowUpInstructionList"),
);
const FollowUpInstructionSave = React.lazy(
  () => import("../pages/FollowUp/FollowUpInstruction/FollowUpInstructionSave"),
);
const ConsumerList = React.lazy(() => import("../pages/Consumer/ConsumerList"));
const ConsumerSave = React.lazy(() => import("../pages/Consumer/ConsumerSave"));
const OrganizationSave = React.lazy(
  () => import("../pages/Organization/OraganizationSave"),
);
const OrganizationList = React.lazy(
  () => import("../pages/Organization/OrganizationList"),
);
const DiagnosisMasterSave = React.lazy(
  () => import("../pages/Diagnosis/DiagnosisMaster/DiagnosisMasterSave"),
);
const DiagnosisMasterList = React.lazy(
  () => import("../pages/Diagnosis/DiagnosisMaster/DiagnosisMasterList"),
);
const FollowUpDurationSave = React.lazy(
  () => import("../pages/FollowUp/FollowUpDuration/FollowUpDurationSave"),
);
const FollowUpDurationList = React.lazy(
  () => import("../pages/FollowUp/FollowUpDuration/FollowUpDurationList"),
);
const DiagnosisTypeList = React.lazy(
  () => import("../pages/Diagnosis/DiagnosisType/DiagnosisTypeList"),
);
const DiagnosisTypeSave = React.lazy(
  () => import("../pages/Diagnosis/DiagnosisType/DiagnosisTypeSave"),
);
const ICDCodeList = React.lazy(
  () => import("../pages/Diagnosis/ICDCodes/ICDCodeList"),
);

const ICDCodeSave = React.lazy(
  () => import("../pages/Diagnosis/ICDCodes/ICDCodeSave"),
);

const InstructionList = React.lazy(
  () => import("../pages/Instruction/InstructionList"),
);
const InstructionSave = React.lazy(
  () => import("../pages/Instruction/InstructionSave"),
);

const QuickNotesList = React.lazy(
  () => import("../pages/QuickNotes/QuickNotesList"),
);

const QuickNotesSave = React.lazy(
  () => import("../pages/QuickNotes/QuickNotesSave"),
);

const InvestigationMasterList = React.lazy(
  () =>
    import("../pages/Investigation/InvestigationMaster/InvestigationMasterList"),
);
const InvestigationMasterSave = React.lazy(
  () =>
    import("../pages/Investigation/InvestigationMaster/InvestigationMasterSave"),
);
const MedicineTemplateList = React.lazy(
  () => import("../pages/Template/MedicineTemplate/MedicineTemplateList"),
);
const MedicineGenericNameList = React.lazy(
  () => import("../pages/Medicine/MedicineGenericName/MedicineGenericNameList"),
);
const MedicineGenericNameSave = React.lazy(
  () => import("../pages/Medicine/MedicineGenericName/MedicineGenericNameSave"),
);
const MedicinecompanyList = React.lazy(
  () => import("../pages/Medicine/Medicinecompany/MedicinecompanyList"),
);
const MedicinecompanySave = React.lazy(
  () => import("../pages/Medicine/Medicinecompany/MedicinecompanySave"),
);
const MedicineGroupList = React.lazy(
  () => import("../pages/Medicine/MedicineGroup/MedicineGroupList"),
);
const MedicineGroupSave = React.lazy(
  () => import("../pages/Medicine/MedicineGroup/MedicineGroupSave"),
);
const MedicineRouteOfAdministrationList = React.lazy(
  () =>
    import("../pages/Medicine/MedicineRouteofAdministration/MedicinerouteofadministrationList"),
);
const MedicineRouteOfAdministrationSave = React.lazy(
  () =>
    import("../pages/Medicine/MedicineRouteofAdministration/MedicinerouteofadministrationSave"),
);
const MedicineRelationtoFoodList = React.lazy(
  () =>
    import("../pages/Medicine/MedicineRelationtoFood/MedicineRelationtoFoodList"),
);
const MedicineRelationtoFoodListSave = React.lazy(
  () =>
    import("../pages/Medicine/MedicineRelationtoFood/MedicineRelationtoFoodSave"),
);
const MedicineIndicationforSOSmedicineList = React.lazy(
  () =>
    import("../pages/Medicine/MedicineIndicationforSOSmedicine/MedicineIndicationforSOSmedicineList"),
);
const MedicineIndicationforSOSmedicineSave = React.lazy(
  () =>
    import("../pages/Medicine/MedicineIndicationforSOSmedicine/MedicineIndicationforSOSmedicineSave"),
);

const MedicineFormulationList = React.lazy(
  () => import("../pages/Medicine/MedicineFormulation/MedicineFormulationList"),
);
const MedicineFormulationSave = React.lazy(
  () => import("../pages/Medicine/MedicineFormulation/MedicineFormulationSave"),
);
const MedicineUsedAsList = React.lazy(
  () => import("../pages/Medicine/MedicineUsedAs/MedicineUsedAsList"),
);
const MedicineUsedAsSave = React.lazy(
  () => import("../pages/Medicine/MedicineUsedAs/MedicineUsedAsSave"),
);
const MedicineDiluentNameList = React.lazy(
  () => import("../pages/Medicine/MedicineDiluentName/MedicineDiluentNameList"),
);
const MedicineDiluentNameSave = React.lazy(
  () => import("../pages/Medicine/MedicineDiluentName/MedicineDiluentNameSave"),
);
const MedicineTemplateSave = React.lazy(
  () => import("../pages/Template/MedicineTemplate/MedicineTemplateSave"),
);
// const DiagnosisTemplateList = React.lazy(
//   () => import("../pages/Template/DiagnosisTemplate/DiagnosisTemplateList")
// );
// const DiagnosisTemplateSave = React.lazy(
//   () => import("../pages/Template/DiagnosisTemplate/DiagnosisTemplateSave")
// );
const InstrunctionTemplateList = React.lazy(
  () =>
    import("../pages/Template/InstrunctionTemplate/InstructionTemplateList"),
);
const InstrunctionTemplateSave = React.lazy(
  () =>
    import("../pages/Template/InstrunctionTemplate/InstructionTemplateSave"),
);
const InvestigationTemplateSave = React.lazy(
  () =>
    import("../pages/Template/InvestigationTemplate/InvestigationTemplateSave"),
);
const InvestigationTemplateList = React.lazy(
  () =>
    import("../pages/Template/InvestigationTemplate/InvestigationTemplateList"),
);
const LaboratoryList = React.lazy(
  () => import("../pages/Laboratory/LaboratoryList"),
);
const LaboratorySave = React.lazy(
  () => import("../pages/Laboratory/LaboratorySave"),
);
const HospitalList = React.lazy(() => import("../pages/Hospital/HospitalList"));
const HospitalSave = React.lazy(() => import("../pages/Hospital/HospitalSave"));
const RefOPDExaminationCerebellarSignsList = React.lazy(
  () =>
    import("../pages/Examiantion/RefOPDExamiantionCerebellarSigns/RefOPDExamiantionCerebellarSignsList"),
);
const RefOPDExaminationCerebellarSignsSave = React.lazy(
  () =>
    import("../pages/Examiantion/RefOPDExamiantionCerebellarSigns/RefOPDExamiantionCerebellarSignsSave"),
);
const RefOPDExamiationResponseToReflexList = React.lazy(
  () =>
    import("../pages/Examiantion/RefOPDExamiationResponseToReflex/RefOPDExamiationResponseToReflexList"),
);
const RefOPDExamiationResponseToReflexSave = React.lazy(
  () =>
    import("../pages/Examiantion/RefOPDExamiationResponseToReflex/RefOPDExamiationResponseToReflexSave"),
);

const SymptomsList = React.lazy(() => import("../pages/Symptoms/SymptomsList"));
const SymptomsSave = React.lazy(() => import("../pages/Symptoms/SymptomsSave"));
const TeamMemberList = React.lazy(
  () => import("../pages/Team/Staff/TeamMemberList"),
);
const TeamMemberSave = React.lazy(
  () => import("../pages/Team/Staff/TeamMemberSave"),
);
const LeadList = React.lazy(() => import("../pages/Crm/Lead/LeadList"));
const LeadSave = React.lazy(() => import("../pages/Crm/Lead/LeadSave"));
const DistributeList = React.lazy(
  () => import("../pages/Crm/Distribute/DistributeList"),
);
const DistributeSave = React.lazy(
  () => import("../pages/Crm/Distribute/DistributeSave"),
);
const PatientMasterList = React.lazy(
  () => import("../pages/Patient/PatientMaster/PatientMasterList"),
);
const PatientMasterSave = React.lazy(
  () => import("../pages/Patient/PatientMaster/PatientMasterSave"),
);
const PatientVaccineModuleSave = React.lazy(
  () =>
    import("../pages/Patient/PatientVaccineModule/PatientVaccineModuleSave"),
);
const MedicalRepresentativeSave = React.lazy(
  () =>
    import("../pages/MedicalRepresentative/MedicalRepresentativeMaster/MedicalRepresentativeSave"),
);
const MedicalRepresentativeList = React.lazy(
  () =>
    import("../pages/MedicalRepresentative/MedicalRepresentativeMaster/MedicalRepresentativeList"),
);
const UsersSave = React.lazy(() => import("../pages/Team/Users/UsersSave"));
const UsersList = React.lazy(() => import("../pages/Team/Users/UsersList"));
const DoctorList = React.lazy(
  () => import("../pages/Doctor/Doctor/DoctorList"),
);
const DoctorSave = React.lazy(
  () => import("../pages/Doctor/Doctor/DoctorSave"),
);
const AddAppointment = React.lazy(
  () => import("../pages/FrontDesk/AddAppointment/AddAppointment"),
);

const DentalMapping = React.lazy(
  () => import("../pages/OPD/OPDClinical/Components/Dental/DentureMapping"),
);

const Appointments = React.lazy(
  () => import("../pages/FrontDesk/ReceptionAppointments/Appointments"),
);
const ReportCertificate = React.lazy(
  () => import("../pages/OPD/Certificates/ReportCertificate"),
);
const PatientHistory = React.lazy(
  () => import("../pages/Patient/PatientHistory/PatientHistory"),
);
const DoctorSchedule = React.lazy(
  () => import("../pages/Doctor/DoctorSchedule/DoctorSchedule"),
);
const DoctorAvailableDays = React.lazy(
  () => import("../pages/DoctorAvailable/AvailableDaysAppointmentBooking"),
);

const AppointmentThankyou = React.lazy(
  () => import("../pages/DoctorAvailable/AppointmentThankyou"),
);
// const OutrichVisits = React.lazy(
//   () => import("../pages/Doctor/OutrichVisits/OutrichVisits")
// );
const BillingList = React.lazy(
  () => import("../pages/Accounts/Billing/BillingList"),
);
const Report = React.lazy(() => import("../pages/Report/Report"));
const BillingSave = React.lazy(
  () => import("../pages/Accounts/Billing/BillingSave"),
);
const PaymentSave = React.lazy(
  () => import("../pages/Accounts/Billing/PaymentSave"),
);
const PaymentList = React.lazy(
  () => import("../pages/Accounts/Billing/PaymentList"),
);
const LanguageSave = React.lazy(
  () => import("../pages/Settings/Language/LanguageSave"),
);

const AddMr = React.lazy(() => import("../pages/FrontDesk/AddMr/AddMr"));
const ProcedureTemplate = React.lazy(
  () => import("../pages/Template/ProcedureTemplate/ProcedureTemplate"),
);
const ReportCertificateTemplate = React.lazy(
  () =>
    import("../pages/Template/ReportCertificateTemplate/ReportCertificateTemplate"),
);
const OPDClinical = React.lazy(
  () => import("../pages/OPD/OPDClinical/OPDClinical"),
);

const OPDClinicalDetail = React.lazy(
  () => import("../pages/OPD/OPDClinical/OPDClinicalDetail"),
);

const ProcedureTemplateSave = React.lazy(
  () => import("../pages/Template/ProcedureTemplate/ProcedureTemplateSave"),
);
const ReportCertificateTemplateSave = React.lazy(
  () =>
    import("../pages/Template/ReportCertificateTemplate/ReportCertificateTemplateSave"),
);
const ReportCertificatesSave = React.lazy(
  () => import("../pages/OPD/Certificates/ReportCertificateSave"),
);
const Profile = React.lazy(() => import("../pages/Profile/Profile"));
const TaxList = React.lazy(
  () => import("../pages/BillingItem/BillingItemMaster/TaxList"),
);
const TaxSave = React.lazy(
  () => import("../pages/BillingItem/BillingItemMaster/TaxSave"),
);

const SpecialitySave = React.lazy(
  () => import("../pages/Speciality/SpecialitySave"),
);
const Speciality = React.lazy(() => import("../pages/Speciality/Speciality"));

const VaccineGroupList = React.lazy(
  () => import("../pages/Vaccines/VaccineGroupList"),
);
const VaccineGroupSave = React.lazy(
  () => import("../pages/Vaccines/VaccineGroupSave"),
);
const VaccineList = React.lazy(() => import("../pages/Vaccines/VaccineList"));
const VaccineSave = React.lazy(() => import("../pages/Vaccines/VaccineSave"));

const ItemList = React.lazy(() => import("../pages/Item/ItemList"));
const ItemSave = React.lazy(() => import("../pages/Item/ItemSave"));

const RefSymptomAgravatedByList = React.lazy(
  () =>
    import("../pages/ChiefComplaint/RefSymptomAgravatedBy/RefSymptomAgravatedByList"),
);

const RefSymptomAgravatedBySave = React.lazy(
  () =>
    import("../pages/ChiefComplaint/RefSymptomAgravatedBy/RefSymptomAgravatedBySave"),
);

const RefSymptomRelievedByList = React.lazy(
  () =>
    import("../pages/ChiefComplaint/RefSymptomRelievedBy/RefSymptomRelievedByList"),
);

const RefSymptomRelievedBySave = React.lazy(
  () =>
    import("../pages/ChiefComplaint/RefSymptomRelievedBy/RefSymptomRelievedBySave"),
);

const RefSymptomDurationUnitList = React.lazy(
  () =>
    import("../pages/ChiefComplaint/RefSymptomDurationUnit/RefSymptomDurationUnitList"),
);

const RefSymptomDurationUnitSave = React.lazy(
  () =>
    import("../pages/ChiefComplaint/RefSymptomDurationUnit/RefSymptomDurationUnitSave"),
);

const RefSymptomFrequencyUnitList = React.lazy(
  () =>
    import("../pages/ChiefComplaint/RefSymptomFrequencyUnit/RefSymptomFrequencyUnitList"),
);

const RefSymptomFrequencyUnitSave = React.lazy(
  () =>
    import("../pages/ChiefComplaint/RefSymptomFrequencyUnit/RefSymptomFrequencyUnitSave"),
);
const RefSymptomNatureList = React.lazy(
  () => import("../pages/ChiefComplaint/RefSymptomNature/RefSymptomNatureList"),
);

const RefSymptomNatureSave = React.lazy(
  () => import("../pages/ChiefComplaint/RefSymptomNature/RefSymptomNatureSave"),
);
const RefSymptomSeverityList = React.lazy(
  () =>
    import("../pages/ChiefComplaint/RefSymptomSeverity/RefSymptomSeverityList"),
);

const RefSymptomSeveritySave = React.lazy(
  () =>
    import("../pages/ChiefComplaint/RefSymptomSeverity/RefSymptomSeveritySave"),
);
const RefSymptomTimingList = React.lazy(
  () => import("../pages/ChiefComplaint/RefSymptomTiming/RefSymptomTimingList"),
);

const RefSymptomTimingSave = React.lazy(
  () => import("../pages/ChiefComplaint/RefSymptomTiming/RefSymptomTimingSave"),
);
const RefPatientFoodItemList = React.lazy(
  () =>
    import("../pages/ChiefComplaint/RefPatientFoodItem/RefPatientFoodItemList"),
);

const RefHistoryMedicalIllnessSave = React.lazy(
  () =>
    import("../pages/ChiefComplaint/RefPatientMedicalIllness/RefPatientMedicalIllnessSave"),
);
const RefPatientMedicalIllnessList = React.lazy(
  () =>
    import("../pages/ChiefComplaint/RefPatientMedicalIllness/RefPatientMedicalIllnessList"),
);

const RefPatientFoodItemSave = React.lazy(
  () =>
    import("../pages/ChiefComplaint/RefPatientFoodItem/RefPatientFoodItemSave"),
);

const UnitList = React.lazy(() => import("../pages/Unit/UnitList"));
const UnitSave = React.lazy(() => import("../pages/Unit/UnitSave"));

const CategoryList = React.lazy(() => import("../pages/Category/CategoryList"));
const CategorySave = React.lazy(() => import("../pages/Category/CategorySave"));

const StoreList = React.lazy(() => import("../pages/Store/StoreList"));
const StoreSave = React.lazy(() => import("../pages/Store/StoreSave"));

const MedicineList = React.lazy(
  () => import("../pages/Medicine/Medicine/MedicineList"),
);
const MedicineSave = React.lazy(
  () => import("../pages/Medicine/Medicine/MedicineSave"),
);

const Configuration = React.lazy(
  () => import("../pages/Settings/Configuration/Configuration"),
);
const OPDConfiguration = React.lazy(
  () =>
    import("../pages/Settings/Configuration/OPDConfiguration/OPDConfiguration"),
);
const VaccinationConfiguration = React.lazy(
  () =>
    import("../pages/Settings/Configuration/VaccinationConfiguration/VaccinationConfiguration"),
);
const NotificationActivityList = React.lazy(
  () => import("../pages/NotificationReport/NotificationActivityList"),
);

// const RefOPDExamiantionCerebellarSignsList = React.lazy(() => import("../pages/Examiantion/RefOPDExamiantionCerebellarSigns/RefOPDExamiantionCerebellarSignsList"));
// const RefOPDExamiantionCerebellarSignsSave = React.lazy(() => import("../pages/Examiantion/RefOPDExamiantionCerebellarSigns/RefOPDExamiantionCerebellarSignsSave"));

// import Language from "../pages/Settings/Language/Language"

// const ReportCertificateTemplate = React.lazy(
//   () => import("../pages/Template/ReportCertificateTemplate/ReportCertificateTemplate")
// );
// const OPDClinical = React.lazy(
//   () => import("../pages/OPD/OPDClinical/OPDClinical")
// );
const NotificationTemplateList = React.lazy(
  () => import("../pages/NotificationTemplate/NotificationTemplateList"),
);

const UpComingVaccination = React.lazy(
  () => import("../pages/NotificationReport/UpComingVaccination"),
);
const UpComingFollowUp = React.lazy(
  () => import("../pages/NotificationReport/UpComingFollowUp"),
);
const BillSummaryByPayment = React.lazy(
  () => import("../pages/Report/BillSummaryByPayment"),
);
const BillSummaryByPatient = React.lazy(
  () => import("../pages/Report/BillSummaryByPatient"),
);
const BillSummaryByPatientDetail = React.lazy(
  () => import("../pages/Report/BillSummaryByPatientDetail"),
);

const FollowUpTemplateList = React.lazy(
  () => import("../pages/Template/FollowUpTemplate/FollowUpTemplateList"),
);
const FollowUpTemplateSave = React.lazy(
  () => import("../pages/Template/FollowUpTemplate/FollowUpTemplateSave"),
);

const VaccineTemplateList = React.lazy(
  () => import("../pages/Template/VaccineTemplate/VaccineTemplateList"),
);
const VaccineTemplateSave = React.lazy(
  () => import("../pages/Template/VaccineTemplate/VaccineTemplateSave"),
);

const PrescriptionTemplateList = React.lazy(
  () =>
    import("../pages/Template/PrescriptionTemplate/PrescriptionTemplateList"),
);
const PrescriptionTemplateSave = React.lazy(
  () =>
    import("../pages/Template/PrescriptionTemplate/PrescriptionTemplateSave"),
);
const ExaminationTemplateList = React.lazy(
  () => import("../pages/Template/ExaminationTemplate/ExaminationTemplateList"),
);
const ExaminationTemplateSave = React.lazy(
  () => import("../pages/Template/ExaminationTemplate/ExaminationTemplateSave"),
);

const OPDTemplateList = React.lazy(
  () => import("../pages/Template/OPDTemplate/OPDTemplateList"),
);
const OPDTemplateSave = React.lazy(
  () => import("../pages/Template/OPDTemplate/OPDTemplateSave"),
);
const OutReachOPDSave = React.lazy(
  () => import("../pages/Doctor/OutReachOPD/OutReachOPDSave"),
);

const RolesList = React.lazy(() => import("../pages/Team/UserGroup/RolesList"));
const UserGroupAccess = React.lazy(
  () => import("../pages/Team/UserGroupAccess/UserGroupAccess"),
);

const LocationList = React.lazy(() => import("../pages/Location/LocationList"));
const Notification = React.lazy(
  () => import("../pages/Notification/Notification"),
);
const Subscription = React.lazy(
  () => import("../pages/Settings/Subscription/Subscription"),
);
const LocationSave = React.lazy(() => import("../pages/Location/LocationSave"));
const ShortLinkRedirect = React.lazy(
  () => import("../pages/ShortLink/ShortLinkRedirect"),
);

export default function RootNavigation() {
  return <RootNavigator />;
}

// function AuthRoute(props: any) {
//     const { userContext, updateUserContext } = React.useContext(PreferencesContext);
//     // if (userContext.userId > 0) {
//     if (userContext.mobileNumber !== "") {
//         return props.children;
//     } else {
//         return <Navigate to="/" replace />;
//     }
// }

function RootNavigator() {
  return (
    <Routes>
      {/* PUBLIC SHORT LINK */}
      <Route
        path="r"
        element={
          <Suspense fallback={<LoadingFallback />}>
            <ShortLinkRedirect />
          </Suspense>
        }
      />
      <Route path="/" element={<App />}>
        <Route
          path="/"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <SignInCover />
            </Suspense>
          }
        >
          <Route
            index
            element={
              <Suspense fallback={<LoadingFallback />}>
                <SignIn />
              </Suspense>
            }
          />
          <Route
            path="sign-up"
            element={
              <Suspense fallback={<LoadingFallback />}>
                <SignUp />
              </Suspense>
            }
          />
          <Route
            path="thank-You"
            element={
              <Suspense fallback={<LoadingFallback />}>
                <ThankYou />
              </Suspense>
            }
          />
          <Route
            element={
              <Suspense fallback={<LoadingFallback />}>
                <ForgotPassword />
              </Suspense>
            }
            path="forgot-password"
          />
          <Route
            element={
              <Suspense fallback={<LoadingFallback />}>
                <ResetPassword />
              </Suspense>
            }
            path="reset-password"
          />
        </Route>
        <Route
          path="manage-user"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <ManageUser />
            </Suspense>
          }
        />
        {/* Fetal Lies */}

        <Route
          path="refer-book-entry"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <ReferBookEntry />
            </Suspense>
          }
        />
        <Route path="appointment-booking">
          <Route
            index
            element={
              <Suspense fallback={<LoadingFallback />}>
                <DoctorAvailableDays />
              </Suspense>
            }
          />
        </Route>
        <Route path="appointment-success">
          <Route
            index
            element={
              <Suspense fallback={<LoadingFallback />}>
                <AppointmentThankyou />
              </Suspense>
            }
          />
        </Route>
        <Route
          path="refer-book-thank-You"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <ReferBookThankYou />
            </Suspense>
          }
        />
        <Route
          path="refer-book-preview"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <ReferBookPreview />
            </Suspense>
          }
        />
        <Route
          path="refer-book"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <ReferBook />
            </Suspense>
          }
        />
        <Route
          path="refer-book-report"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <ReferBookReport />
            </Suspense>
          }
        />
        <Route
          path="prescription"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <PrescriptionReport />
            </Suspense>
          }
        />
        <Route
          path="billing-shared"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <BillingReport />
            </Suspense>
          }
        />
        <Route
          path="certificate-report"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <CertificateReport />
            </Suspense>
          }
        />
        <Route
          path="growth-chart-report"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <GrowthChartReport />
            </Suspense>
          }
        />
        <Route
          path="prescription-report"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <FullPrescriptionReport />
            </Suspense>
          }
        />
        <Route
          path="opd-clinical-detail"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <OPDClinicalDetail />
            </Suspense>
          }
        />
        <Route
          path="opd-clinical-preview"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <OPDClinicalPreview />
            </Suspense>
          }
        />
        <Route
          path="/"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <SignInCover />
            </Suspense>
          }
        >
          <Route
            index
            element={
              <Suspense fallback={<LoadingFallback />}>
                <SignIn />
              </Suspense>
            }
          />
          <Route
            path="sign-up"
            element={
              <Suspense fallback={<LoadingFallback />}>
                <SignUp />
              </Suspense>
            }
          />
          <Route
            path="thank-You"
            element={
              <Suspense fallback={<LoadingFallback />}>
                <ThankYou />
              </Suspense>
            }
          />
          <Route
            element={
              <Suspense fallback={<LoadingFallback />}>
                <ForgotPassword />
              </Suspense>
            }
            path="forgot-password"
          />
          <Route
            element={
              <Suspense fallback={<LoadingFallback />}>
                <ResetPassword />
              </Suspense>
            }
            path="reset-password"
          />
        </Route>
        <Route path="/" element={<NavBarDrawer children={undefined} />}>
          <Route path="dashboard">
            <Route
              index
              element={
                <Suspense fallback={<LoadingFallback />}>
                  <Dashboard />
                </Suspense>
              }
            />
          </Route>
          <Route
            path="abha"
            element={
              <Suspense fallback={<LoadingFallback />}>
                <AbdmAbha />
              </Suspense>
            }
          />
          <Route
            path="hfr"
            element={
              <Suspense fallback={<LoadingFallback />}>
                <AbdmHfr />
              </Suspense>
            }
          />
          <Route
            path="hpr"
            element={
              <Suspense fallback={<LoadingFallback />}>
                <AbdmHpr />
              </Suspense>
            }
          />
          <Route
            path="health-records"
            element={
              <Suspense fallback={<LoadingFallback />}>
                <AbdmHealthRecords />
              </Suspense>
            }
          />
          <Route
            path="consent"
            element={
              <Suspense fallback={<LoadingFallback />}>
                <AbdmConsent />
              </Suspense>
            }
          />
          {/* Keep old flat URLs working if bookmarked */}
          <Route
            path="abha"
            element={
              <Suspense fallback={<LoadingFallback />}>
                <AbdmAbha />
              </Suspense>
            }
          />
          <Route
            path="hfr"
            element={
              <Suspense fallback={<LoadingFallback />}>
                <AbdmHfr />
              </Suspense>
            }
          />
          <Route
            path="hpr"
            element={
              <Suspense fallback={<LoadingFallback />}>
                <AbdmHpr />
              </Suspense>
            }
          />
          <Route
            path="health-records"
            element={
              <Suspense fallback={<LoadingFallback />}>
                <AbdmHealthRecords />
              </Suspense>
            }
          />
          <Route
            path="consent"
            element={
              <Suspense fallback={<LoadingFallback />}>
                <AbdmConsent />
              </Suspense>
            }
          />
          <Route path="clinical-analytics">
            <Route
              index
              element={
                <Suspense fallback={<LoadingFallback />}>
                  <ClinicalAnalytics />
                </Suspense>
              }
            />
          </Route>
          <Route path="dental-analytics">
            <Route
              index
              element={
                <Suspense fallback={<LoadingFallback />}>
                  <DentalAnalytics />
                </Suspense>
              }
            />
          </Route>
          <Route path="calendar">
            <Route
              index
              element={
                <Suspense fallback={<LoadingFallback />}>
                  <Calendar />
                </Suspense>
              }
            />
          </Route>
          <Route element={<AuthGuard disallowedRoles={["user"]} />}>
            <Route path="users">
              <Route
                index
                element={
                  <Suspense fallback={<LoadingFallback />}>
                    <UsersList />
                  </Suspense>
                }
              />
              <Route
                path="users-save"
                element={
                  <Suspense fallback={<LoadingFallback />}>
                    <UsersSave />
                  </Suspense>
                }
              />
            </Route>
          </Route>
          <Route element={<AuthGuard allowedRoles={["superadmin"]} />}>
            <Route path="lead">
              <Route
                index
                element={
                  <Suspense fallback={<LoadingFallback />}>
                    <LeadList />
                  </Suspense>
                }
              />
              <Route
                path="lead-save"
                element={
                  <Suspense fallback={<LoadingFallback />}>
                    <LeadSave />
                  </Suspense>
                }
              />
            </Route>
            <Route path="distribute">
              <Route
                index
                element={
                  <Suspense fallback={<LoadingFallback />}>
                    <DistributeList />
                  </Suspense>
                }
              />
              <Route
                path="distribute-save"
                element={
                  <Suspense fallback={<LoadingFallback />}>
                    <DistributeSave />
                  </Suspense>
                }
              />
            </Route>
            <Route path="consumers">
              <Route
                index
                element={
                  <Suspense fallback={<LoadingFallback />}>
                    <ConsumerList />
                  </Suspense>
                }
              />
              <Route
                element={
                  <Suspense fallback={<LoadingFallback />}>
                    <ConsumerSave />
                  </Suspense>
                }
                path="consumer-save"
              />
            </Route>
          </Route>
          <Route path="patient-master">
            <Route
              index
              element={
                <Suspense fallback={<LoadingFallback />}>
                  <PatientMasterList />
                </Suspense>
              }
            />
            <Route
              element={
                <Suspense fallback={<LoadingFallback />}>
                  <PatientMasterSave />
                </Suspense>
              }
              path="patient-master-save"
            />
            <Route
              element={
                <Suspense fallback={<LoadingFallback />}>
                  <PatientVaccineModuleSave />
                </Suspense>
              }
              path="patient-vaccine-module-save"
            />
          </Route>
          <Route element={<AuthGuard disallowedRoles={["user"]} />}>
            <Route path="settings">
              <Route
                index
                element={
                  <Suspense fallback={<LoadingFallback />}>
                    <Settings />
                  </Suspense>
                }
              />
              <Route path="organization">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OrganizationList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OrganizationSave />
                    </Suspense>
                  }
                  path="organization-save"
                />
              </Route>
              <Route path="branch">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <BranchList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <BranchSave />
                    </Suspense>
                  }
                  path="branch-save"
                />
              </Route>
              <Route path="department">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <DepartmentList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <DepartmentSave />
                    </Suspense>
                  }
                  path="department-save"
                />
              </Route>
              <Route path="speciality">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <Speciality />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <SpecialitySave />
                    </Suspense>
                  }
                  path="speciality-save"
                />
              </Route>
              {/* <Route path="ref-opd-examiantion-cerebellar-signs">
              <Route
                index
                element={
                  <Suspense fallback={<LoadingFallback />}>
                    <RefOPDExamiantionCerebellarSignsList />
                  </Suspense>
                }
              />
              <Route
                element={
                  <Suspense fallback={<LoadingFallback />}>
                    <RefOPDExamiantionCerebellarSignsSave />
                  </Suspense>
                }
                path="ref-opd-examiantion-cerebellar-signs-save"
              />
            </Route> */}
              <Route
                element={
                  <Suspense fallback={<LoadingFallback />}>
                    <LanguageSave />
                  </Suspense>
                }
                path="language"
              />
              <Route path="configuration">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <Configuration />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OPDConfiguration />
                    </Suspense>
                  }
                  path="opd-configuration"
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <VaccinationConfiguration />
                    </Suspense>
                  }
                  path="Vaccination-Configuration"
                />
                <Route path="report-parameter-configuration">
                  <Route
                    index
                    element={
                      <Suspense fallback={<LoadingFallback />}>
                        <ReportParameterList />
                      </Suspense>
                    }
                  />
                  <Route
                    element={
                      <Suspense fallback={<LoadingFallback />}>
                        <ReportParameterSave />
                      </Suspense>
                    }
                    path="report-parameter-configuration-save"
                  />
                </Route>
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <BillingConfiguration />
                    </Suspense>
                  }
                  path="billing-configuration"
                />
              </Route>
              <Route path="location">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <LocationList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <LocationSave />
                    </Suspense>
                  }
                  path="location-save"
                />
              </Route>
              <Route path="notification">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <Notification />
                    </Suspense>
                  }
                />
              </Route>
              <Route path="subscription">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <Subscription />
                    </Suspense>
                  }
                />
              </Route>
            </Route>
          </Route>
          <Route path="help">
            <Route
              index
              element={
                <Suspense fallback={<LoadingFallback />}>
                  <Help />
                </Suspense>
              }
            />
          </Route>

          <Route element={<AuthGuard disallowedRoles={["user"]} />}>
            <Route path="master">
              {/* Breast Examination Navigation */}
              <Route path="breast-examination">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefOBGyExaminationBreastExaminationList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefOBGyExaminationBreastExaminationSave />
                    </Suspense>
                  }
                  path="breast-examination-save"
                />
              </Route>

              {/* Per Vaginal Examination Navigation */}
              <Route path="per-vaginal-examination">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefOBGyExaminationPerVaginalExaminationList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefOBGyExaminationPerVaginalExaminationSave />
                    </Suspense>
                  }
                  path="per-vaginal-examination-save"
                />
              </Route>
              {/* Type Of USG navigation */}
              <Route path="type-of-Usg">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefOBGyExaminationTypeOfUSGList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefOBGyExaminationTypeOfUSGSave />
                    </Suspense>
                  }
                  path="type-of-usg-save"
                />
              </Route>
              <Route path="fetal-lies">
                {/* {console.log("Route: fetal-lies matched")} */}
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefOBGyExaminationFetalLiesList />
                    </Suspense>
                  }
                />
              </Route>
              <Route path="fetal-presenting-part">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <FetalPresentingPartList />
                    </Suspense>
                  }
                />
              </Route>
              <Route path="fetal-position">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <FetalPositionList />
                    </Suspense>
                  }
                />
              </Route>
              {/* Liquor navigation */}
              <Route path="liquor">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefOBGyExaminationLiquorList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefOBGyExaminationLiquorSave />
                    </Suspense>
                  }
                  path="liquor-save"
                />
              </Route>
              {/* Doppler Findings navigation */}
              <Route path="doppler-findings">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefOBGyExaminationDopplerFindingsList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefOBGyExaminationDopplerFindingsSave />
                    </Suspense>
                  }
                  path="doppler-findings-save"
                />
              </Route>
              {/* Doppler Findings navigation */}
              <Route path="fetal-heart-rate-description">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefOBGyExaminationFetalHeartRateDescriptionList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefOBGyExaminationFetalHeartRateDescriptionSave />
                    </Suspense>
                  }
                  path="fetal-heart-rate-description-save"
                />
              </Route>

              {/* Changes - yash*/}
              {/*Uterus Shape Navigation */}
              <Route path="uterus-shape">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefOBGyExaminationUterusShapeList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefOBGyExaminationUterusShapeSave />
                    </Suspense>
                  }
                  path="uterus-shape-save"
                />
              </Route>

              {/*Uterus Measurement navigation */}
              <Route path="uterus-measurement">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefOBGyExaminationUterusMeasurementList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefOBGyExaminationUterusMeasurementSave />
                    </Suspense>
                  }
                  path="uterus-measurement-save"
                />
              </Route>

              {/*ovary Description Navigation */}
              <Route path="ovary-description">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefOBGyExaminationOvaryDescriptionList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefOBGyExaminationOvaryDescriptionSave />
                    </Suspense>
                  }
                  path="ovary-description-save"
                />
              </Route>

              <Route
                index
                element={
                  <Suspense fallback={<LoadingFallback />}>
                    <Master />
                  </Suspense>
                }
              />
              <Route path="dental-history">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefHistoryDentalHistoryList />
                    </Suspense>
                  }
                />
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefHistoryDentalHistorySave />
                    </Suspense>
                  }
                  path="dental-history-save"
                />
              </Route>
              <Route path="examination">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefMemberProcedureExaminationList />
                    </Suspense>
                  }
                />
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefMemberProcedureExaminationSave />
                    </Suspense>
                  }
                  path="examination-save"
                />
              </Route>
              <Route path="procedure-list">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <ProcedureList />
                    </Suspense>
                  }
                />
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <ProcedureSave />
                    </Suspense>
                  }
                  path="procedure-save"
                />

                {/* </Route> */}
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <Master />
                    </Suspense>
                  }
                />
              </Route>
              <Route path="skip-tooth-selection-list">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <GeneralProcedureList />
                    </Suspense>
                  }
                />
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <GeneralProcedureSave />
                    </Suspense>
                  }
                  path="skip-tooth-selection-save"
                />

                {/* </Route> */}
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <Master />
                    </Suspense>
                  }
                />
              </Route>
              <Route path="surgery-site-or-anatomical-location-list">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <GeneralProcedureList />
                    </Suspense>
                  }
                />
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <GeneralProcedureSave />
                    </Suspense>
                  }
                  path="surgery-site-or-anatomical-location-save"
                />

                {/* </Route> */}
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <Master />
                    </Suspense>
                  }
                />
              </Route>
              <Route path="investigation-sample-collected-from-list">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <InvestigationSampleCollectedFromList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <InvestigationSampleCollectedFromSave />
                    </Suspense>
                  }
                  path="investigation-sample-collected-from-save"
                />
              </Route>
              <Route path="doctor">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <DoctorList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <DoctorSave />
                    </Suspense>
                  }
                  path="doctor-save"
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OutReachOPDSave />
                    </Suspense>
                  }
                  path="out-reach-opd"
                />
              </Route>
              <Route path="vaccine-group">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <VaccineGroupList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <VaccineGroupSave />
                    </Suspense>
                  }
                  path="vaccine-group-save"
                />
              </Route>
              <Route path="vaccine">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <VaccineList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <VaccineSave />
                    </Suspense>
                  }
                  path="vaccine-save"
                />
              </Route>
              <Route path="item">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <ItemList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <ItemSave />
                    </Suspense>
                  }
                  path="item-save"
                />
              </Route>
              <Route path="unit">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <UnitList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <UnitSave />
                    </Suspense>
                  }
                  path="unit-save"
                />
              </Route>
              <Route path="category">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <CategoryList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <CategorySave />
                    </Suspense>
                  }
                  path="category-save"
                />
              </Route>
              <Route path="store">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <StoreList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <StoreSave />
                    </Suspense>
                  }
                  path="store-save"
                />
              </Route>
              <Route path="medicine">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <MedicineList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <MedicineSave />
                    </Suspense>
                  }
                  path="medicine-save"
                />
              </Route>
              <Route path="medical-representative">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <MedicalRepresentativeList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <MedicalRepresentativeSave />
                    </Suspense>
                  }
                  path="medical-representative-save"
                />
              </Route>
              <Route path="diagnosis-type">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <DiagnosisTypeList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <DiagnosisTypeSave />
                    </Suspense>
                  }
                  path="diagnosis-type-save"
                />
              </Route>
              <Route path="icd-codes">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <ICDCodeList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <ICDCodeSave />
                    </Suspense>
                  }
                  path="icd-codes-save"
                />
              </Route>
              <Route path="diagnosis-master">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <DiagnosisMasterList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <DiagnosisMasterSave />
                    </Suspense>
                  }
                  path="diagnosis-master-save"
                />
              </Route>
              <Route path="medicine-dose">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <MedicineDoseList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <MedicineDoseSave />
                    </Suspense>
                  }
                  path="medicine-dose-save"
                />
              </Route>
              <Route path="medicine-group">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <MedicineGroupList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <MedicineGroupSave />
                    </Suspense>
                  }
                  path="medicine-group-save"
                />
              </Route>
              <Route path="medicine-route-of-administration">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <MedicineRouteOfAdministrationList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <MedicineRouteOfAdministrationSave />
                    </Suspense>
                  }
                  path="medicine-route-of-administration-save"
                />
              </Route>
              <Route path="medicine-relation-to-food">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <MedicineRelationtoFoodList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <MedicineRelationtoFoodListSave />
                    </Suspense>
                  }
                  path="medicine-relation-to-food-save"
                />
              </Route>
              <Route path="medicine-indication-for-sos-medicine">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <MedicineIndicationforSOSmedicineList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <MedicineIndicationforSOSmedicineSave />
                    </Suspense>
                  }
                  path="medicine-indication-for-sos-medicine-save"
                />
              </Route>
              <Route path="medicine-Generic-name">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <MedicineGenericNameList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <MedicineGenericNameSave />
                    </Suspense>
                  }
                  path="medicine-generic-name-save"
                />
              </Route>
              <Route path="medicine-company">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <MedicinecompanyList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <MedicinecompanySave />
                    </Suspense>
                  }
                  path="medicine-company-save"
                />
              </Route>
              <Route path="medicine-formulation">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <MedicineFormulationList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <MedicineFormulationSave />
                    </Suspense>
                  }
                  path="medicine-formulation-save"
                />
              </Route>
              <Route path="medicine-used-as">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <MedicineUsedAsList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <MedicineUsedAsSave />
                    </Suspense>
                  }
                  path="medicine-used-as-save"
                />
              </Route>
              <Route path="medicine-diluent-name">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <MedicineDiluentNameList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <MedicineDiluentNameSave />
                    </Suspense>
                  }
                  path="medicine-diluent-name-save"
                />
              </Route>
              <Route path="investigation-master">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <InvestigationMasterList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <InvestigationMasterSave />
                    </Suspense>
                  }
                  path="investigation-master-save"
                />
              </Route>
              <Route path="followup-duration">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <FollowUpDurationList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <FollowUpDurationSave />
                    </Suspense>
                  }
                  path="followup-duration-save"
                />
              </Route>
              <Route path="followup-reason">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <FollowUpReasonList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <FollowUpReasonSave />
                    </Suspense>
                  }
                  path="followup-reason-save"
                />
              </Route>
              <Route path="followup-instruction">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <FollowUpInstructionList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <FollowUpInstructionSave />
                    </Suspense>
                  }
                  path="followup-instruction-save"
                />
              </Route>

              <Route path="laboratory">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <LaboratoryList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <LaboratorySave />
                    </Suspense>
                  }
                  path="laboratory-save"
                />
              </Route>

              <Route path="hospital">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <HospitalList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <HospitalSave />
                    </Suspense>
                  }
                  path="hospital-save"
                />
              </Route>
              <Route path="ref-opd-examination-cerebellar-signs">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefOPDExaminationCerebellarSignsList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefOPDExaminationCerebellarSignsSave />
                    </Suspense>
                  }
                  path="ref-opd-examination-cerebellar-signs-save"
                />
              </Route>
              <Route path="ref-opd-examination-response-to-reflex">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefOPDExamiationResponseToReflexList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefOPDExamiationResponseToReflexSave />
                    </Suspense>
                  }
                  path="ref-opd-examination-response-to-reflex-save"
                />
              </Route>

              <Route path="symptoms">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <SymptomsList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <SymptomsSave />
                    </Suspense>
                  }
                  path="symptoms-save"
                />
              </Route>
              <Route path="symptom-agravated-by">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefSymptomAgravatedByList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefSymptomAgravatedBySave />
                    </Suspense>
                  }
                  path="symptom-agravated-by-save"
                />
              </Route>
              <Route path="symptom-relieved-by">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefSymptomRelievedByList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefSymptomRelievedBySave />
                    </Suspense>
                  }
                  path="symptom-relieved-by-save"
                />
              </Route>
              <Route path="symptom-duration-unit">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefSymptomDurationUnitList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefSymptomDurationUnitSave />
                    </Suspense>
                  }
                  path="symptom-duration-unit-save"
                />
              </Route>
              <Route path="symptom-frequency-unit">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefSymptomFrequencyUnitList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefSymptomFrequencyUnitSave />
                    </Suspense>
                  }
                  path="symptom-frequency-unit-save"
                />
              </Route>
              <Route path="symptom-nature">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefSymptomNatureList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefSymptomNatureSave />
                    </Suspense>
                  }
                  path="symptom-nature-save"
                />
              </Route>
              <Route path="symptom-severity">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefSymptomSeverityList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefSymptomSeveritySave />
                    </Suspense>
                  }
                  path="symptom-severity-save"
                />
              </Route>

              <Route path="symptom-timing">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefSymptomTimingList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefSymptomTimingSave />
                    </Suspense>
                  }
                  path="symptom-timing-save"
                />
              </Route>
              <Route path="patient-food-item">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefPatientFoodItemList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefPatientFoodItemSave />
                    </Suspense>
                  }
                  path="patient-food-item-save"
                />
              </Route>
              <Route path="history-of-medical-illness">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefPatientMedicalIllnessList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefHistoryMedicalIllnessSave />
                    </Suspense>
                  }
                  path="history-of-medical-illness-save"
                />
              </Route>

              <Route path="type-of-surgery">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefHistoryOBGyHistoryTypeOfSurgeryList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefHistoryOBGyHistoryTypeOfSurgerySave />
                    </Suspense>
                  }
                  path="type-of-surgery-save"
                />
              </Route>
              <Route path="outcome-of-surgery">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefHistoryOBGyHistoryOutcomeOfSurgeryList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefHistoryOBGyHistoryOutcomeOfSurgerySave />
                    </Suspense>
                  }
                  path="outcome-of-surgery-save"
                />
              </Route>
              <Route path="details-of-congenital-anomaly">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefHistoryOBGyHistoryDetailsOfCongenitalAnomalyList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefHistoryOBGyHistoryDetailsOfCongenitalAnomalySave />
                    </Suspense>
                  }
                  path="details-of-congenital-anomaly-save"
                />
              </Route>
              <Route path="type-of-art">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefHistoryOBGyHistoryTypeOfARTList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefHistoryOBGyHistoryTypeOfARTSave />
                    </Suspense>
                  }
                  path="type-of-art-save"
                />
              </Route>

              {/*Events During ART navigation*/}
              <Route path="event-during-art">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefHistoryOBGyHistoryEventsDuringARTList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefHistoryOBGyHistoryEventsDuringARTSave />
                    </Suspense>
                  }
                  path="event-during-art-save"
                />
              </Route>

              {/*Outcome Of Art Navigation */}
              <Route path="outcome-of-art">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefHistoryOBGyHistoryOutcomeOfARTList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefHistoryOBGyHistoryOutcomeOfARTSave />
                    </Suspense>
                  }
                  path="outcome-of-art-save"
                />
              </Route>

              {/* Menstrual Duration navigation  */}
              <Route path="menstrual-duration">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefHistoryOBGyHistoryMenstrualDurationList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefHistoryOBGyHistoryMenstrualDurationSave />
                    </Suspense>
                  }
                  path="menstrual-duration-save"
                />
              </Route>

              {/*Menstrual Nature Navigation */}
              <Route path="menstrual-nature">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefHistoryOBGyHistoryMenstrualNatureList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <RefHistoryOBGyHistoryMenstrualNatureSave />
                    </Suspense>
                  }
                  path="menstrual-nature-save"
                />
              </Route>

              <Route path="tax">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <TaxList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <TaxSave />
                    </Suspense>
                  }
                  path="tax-save"
                />
              </Route>
              <Route path="procedure-template">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <ProcedureTemplate />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <ProcedureTemplateSave />
                    </Suspense>
                  }
                  path="procedure-template-save"
                />
              </Route>
              <Route path="report-certificate-template">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <ReportCertificateTemplate />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <ReportCertificateTemplateSave />
                    </Suspense>
                  }
                  path="report-certificate-template-save"
                />
              </Route>

              <Route path="instruction">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <InstructionList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <InstructionSave />
                    </Suspense>
                  }
                  path="instruction-save"
                />
              </Route>

              <Route path="quick-notes">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <QuickNotesList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <QuickNotesSave />
                    </Suspense>
                  }
                  path="quick-notes-save"
                />
              </Route>
              {/* <Route path="notification-template">
              <Route
                index
                element={
                  <Suspense fallback={<LoadingFallback />}>
                    <NotificationTemplateList />
                  </Suspense>
                }
              />
              <Route
                element={
                  <Suspense fallback={<LoadingFallback />}>
                    <NotificationTemplateSave />
                  </Suspense>
                }
                path="notification-template-save"
              />
            </Route> */}
              <Route path="reason-for-reference">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <ReasonForReferenceList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <ReasonForReferenceSave />
                    </Suspense>
                  }
                  path="reason-for-reference-save"
                />
              </Route>
              <Route path="refer-book-entry-list">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <ReferBookEntryList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <ReferBookEntryDetails />
                    </Suspense>
                  }
                  path="refer-book-entry-details"
                />
              </Route>
              <Route path="special-medical-condition-master">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <SpecialMedicalConditionMasterList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <SpecialMedicalConditionMasterSave />
                    </Suspense>
                  }
                  path="special-medical-condition-master-save"
                />
              </Route>

              {/*Visual Acuity */}
              <Route path="unaided-distance-va-master">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalVisualAcuityUnaidedDistanceVAList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalVisualAcuityUnaidedDistanceVASave />
                    </Suspense>
                  }
                  path="unaided-distance-va-save"
                />
              </Route>
              <Route path="pinhole-va-master">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalVisualAcuityPinholeVAList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalVisualAcuityPinholeVASave />
                    </Suspense>
                  }
                  path="pinhole-va-save"
                />
              </Route>
              <Route path="best-corrected-va-master">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalVisualAcuityBestCorrectedVAList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalVisualAcuityBestCorrectedVASave />
                    </Suspense>
                  }
                  path="best-corrected-va-save"
                />
              </Route>
              <Route path="near-vision-master">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalVisualAcuityNearVisionList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalVisualAcuityNearVisionSave />
                    </Suspense>
                  }
                  path="near-vision-save"
                />
              </Route>
              <Route path="final-visual-acuity-master">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalVisualAcuityFinalVisualAcuityList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalVisualAcuityFinalVisualAcuitySave />
                    </Suspense>
                  }
                  path="final-visual-acuity-save"
                />
              </Route>

              {/*Refrection */}
              <Route path="sphere-distant-master">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalRefractionDistantSphereList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalRefractionDistantSphereSave />
                    </Suspense>
                  }
                  path="sphere-distant-save"
                />
              </Route>
              <Route path="sphere-near-master">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalRefractionNearSphereList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalRefractionNearSphereSave />
                    </Suspense>
                  }
                  path="sphere-near-save"
                />
              </Route>
              <Route path="cylinder-master">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalRefractionCylinderList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalRefractionCylinderSave />
                    </Suspense>
                  }
                  path="cylinder-save"
                />
              </Route>
              <Route path="axis-master">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalRefractionAxisList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalRefractionAxisSave />
                    </Suspense>
                  }
                  path="axis-save"
                />
              </Route>
              <Route path="vision-distant-master">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalRefractionDistantVisionList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalRefractionDistantVisionSave />
                    </Suspense>
                  }
                  path="vision-distant-save"
                />
              </Route>
              <Route path="vision-near-master">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalRefractionNearVisionList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalRefractionNearVisionSave />
                    </Suspense>
                  }
                  path="vision-near-save"
                />
              </Route>

              {/* Occular Motility and Pupils */}
              <Route path="extraocular-movements-master">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalOccularMotilityExtraocularMovementsList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalOccularMotilityExtraocularMovementsSave />
                    </Suspense>
                  }
                  path="extraocular-movements-master-save"
                />
              </Route>
              <Route path="pupillary-reaction-master">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalOccularMotilityPupillaryReactionList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalOccularMotilityPupillaryReactionSave />
                    </Suspense>
                  }
                  path="pupillary-reaction-master-save"
                />
              </Route>
              <Route path="rapd-master">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalOccularMotilityRAPDList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalOccularMotilityRAPDSave />
                    </Suspense>
                  }
                  path="rapd-master-save"
                />
              </Route>
              <Route path="visual-fields-by-confrontation-master">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalOccularMotilityVFBCList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalOccularMotilityVFBCSave />
                    </Suspense>
                  }
                  path="visual-fields-by-confrontation-master-save"
                />
              </Route>

              {/* Slit Lamp  */}
              <Route path="eyelids-master">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalSlitLampEyelidsList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalSlitLampEyelidsSave />
                    </Suspense>
                  }
                  path="eyelids-master-save"
                />
              </Route>
              <Route path="conjunctiva-master">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalSlitLampConjunctivaList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalSlitLampConjunctivaSave />
                    </Suspense>
                  }
                  path="conjunctiva-master-save"
                />
              </Route>
              <Route path="cornea-master">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalSlitLampCorneaList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalSlitLampCorneaSave />
                    </Suspense>
                  }
                  path="cornea-master-save"
                />
              </Route>
              <Route path="anterio-chamber-master">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalSlitLampAnteriorChamberList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalSlitLampAnteriorChamberSave />
                    </Suspense>
                  }
                  path="anterio-chamber-master-save"
                />
              </Route>
              <Route path="iris-master">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalSlitLampIrisList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalSlitLampIrisSave />
                    </Suspense>
                  }
                  path="iris-master-save"
                />
              </Route>
              <Route path="lens-master">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalSlitLampLensList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalSlitLampLensSave />
                    </Suspense>
                  }
                  path="lens-master-save"
                />
              </Route>
              {/*Posterior Segment/ Fundus */}
              <Route path="vitreous-master">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalPosteriorSegmentVitreousList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalPosteriorSegmentVitreousSave />
                    </Suspense>
                  }
                  path="vitreous-save"
                />
              </Route>
              <Route path="optic-disc-master">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalPosteriorSegmentOpticDiscList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalPosteriorSegmentOpticDiscSave />
                    </Suspense>
                  }
                  path="optic-disc-save"
                />
              </Route>
              <Route path="cup-to-disc-ratio-master">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalPosteriorSegmentCupToDiscRatioList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalPosteriorSegmentCupToDiscRatioSave />
                    </Suspense>
                  }
                  path="cup-to-disc-ratio-save"
                />
              </Route>
              <Route path="macula-master">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalPosteriorSegmentMaculaList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalPosteriorSegmentMaculaSave />
                    </Suspense>
                  }
                  path="macula-save"
                />
              </Route>
              <Route path="retinal-vessels-master">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalPosteriorSegmentRetinalVesselsList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalPosteriorSegmentRetinalVesselsSave />
                    </Suspense>
                  }
                  path="retinal-vessels-save"
                />
              </Route>
              <Route path="peripheral-retina-master">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalPosteriorSegmentPeripheralRetinaList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalPosteriorSegmentPeripheralRetinaSave />
                    </Suspense>
                  }
                  path="peripheral-retina-save"
                />
              </Route>

              {/*IOP */}
              <Route path="measurement-method-master">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalIOPMeasurementMethodList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OphthalIOPMeasurementMethodSave />
                    </Suspense>
                  }
                  path="measurement-method-save"
                />
              </Route>
            </Route>
          </Route>
          <Route element={<AuthGuard disallowedRoles={["user"]} />}>
            <Route path="notification">
              <Route
                index
                element={
                  <Suspense fallback={<LoadingFallback />}>
                    <NotificationReport />
                  </Suspense>
                }
              />
            </Route>
            <Route path="templates">
              <Route
                index
                element={
                  <Suspense fallback={<LoadingFallback />}>
                    <Templates />
                  </Suspense>
                }
              />
              <Route path="notification-template">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <NotificationTemplateList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <NotificationTemplateSave />
                    </Suspense>
                  }
                  path="notification-template-save"
                />
              </Route>
              <Route path="report-certificate-template">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <ReportCertificateTemplate />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <ReportCertificateTemplateSave />
                    </Suspense>
                  }
                  path="report-certificate-template-save"
                />
              </Route>
              {/* <Route path="diagnosis-template">
              <Route
                index
                element={
                  <Suspense fallback={<LoadingFallback />}>
                    <DiagnosisTemplateList />
                  </Suspense>
                }
              />
              <Route
                element={
                  <Suspense fallback={<LoadingFallback />}>
                    <DiagnosisTemplateSave />
                  </Suspense>
                }
                path="diagnosis-template-save"
              />
            </Route> */}
              <Route path="instruction-template">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <InstrunctionTemplateList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <InstrunctionTemplateSave />
                    </Suspense>
                  }
                  path="instruction-template-save"
                />
              </Route>
              <Route path="medicine-template">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <MedicineTemplateList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <MedicineTemplateSave />
                    </Suspense>
                  }
                  path="medicine-template-save"
                />
              </Route>
              <Route path="investigation-template">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <InvestigationTemplateList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <InvestigationTemplateSave />
                    </Suspense>
                  }
                  path="investigation-template-save"
                />
              </Route>
              <Route path="medicine-template">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <MedicineTemplateList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <MedicineTemplateSave />
                    </Suspense>
                  }
                  path="medicine-template-save"
                />
              </Route>
              <Route path="follow-up-template">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <FollowUpTemplateList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <FollowUpTemplateSave />
                    </Suspense>
                  }
                  path="follow-up-template-save"
                />
              </Route>
              <Route path="vaccine-template">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <VaccineTemplateList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <VaccineTemplateSave />
                    </Suspense>
                  }
                  path="vaccine-template-save"
                />
              </Route>
              <Route path="prescription-template">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <PrescriptionTemplateList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <PrescriptionTemplateSave />
                    </Suspense>
                  }
                  path="prescription-template-save"
                />
              </Route>
              <Route path="examination-template">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <ExaminationTemplateList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <ExaminationTemplateSave />
                    </Suspense>
                  }
                  path="examination-template-save"
                />
              </Route>
              <Route path="opd-template">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OPDTemplateList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <OPDTemplateSave />
                    </Suspense>
                  }
                  path="opd-template-save"
                />
              </Route>
              <Route path="history-template">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <HistoryTemplateList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <HistoryTemplateSave />
                    </Suspense>
                  }
                  path="history-template-save"
                />
              </Route>
              <Route path="diagnosis-template">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <DiagnosisTemplateList />
                    </Suspense>
                  }
                />
                <Route
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <DiagnosisTemplateSave />
                    </Suspense>
                  }
                  path="diagnosis-template-save"
                />
              </Route>
            </Route>
          </Route>
          <Route element={<AuthGuard disallowedRoles={["user"]} />}>
            <Route path="team-member">
              <Route
                index
                element={
                  <Suspense fallback={<LoadingFallback />}>
                    <TeamMemberList />
                  </Suspense>
                }
              />
              <Route
                element={
                  <Suspense fallback={<LoadingFallback />}>
                    <TeamMemberSave />
                  </Suspense>
                }
                path="team-member-save"
              />
              <Route
                element={
                  <Suspense fallback={<LoadingFallback />}>
                    <OutReachOPDSave />
                  </Suspense>
                }
                path="out-reach-opd"
              />
            </Route>
            <Route path="roles">
              <Route
                index
                element={
                  <Suspense fallback={<LoadingFallback />}>
                    <RolesList />
                  </Suspense>
                }
              />
              <Route
                element={
                  <Suspense fallback={<LoadingFallback />}>
                    <RolesSave />
                  </Suspense>
                }
                path="roles-save"
              />
            </Route>
            <Route path="user-group-access">
              <Route
                index
                element={
                  <Suspense fallback={<LoadingFallback />}>
                    <UserGroupAccess />
                  </Suspense>
                }
              />
            </Route>
            <Route path="report-certificate">
              <Route
                index
                element={
                  <Suspense fallback={<LoadingFallback />}>
                    <ReportCertificate />
                  </Suspense>
                }
              />
              <Route
                element={
                  <Suspense fallback={<LoadingFallback />}>
                    <ReportCertificatesSave />
                  </Suspense>
                }
                path="report-certificate-save"
              />
            </Route>
          </Route>
          <Route path="billing">
            <Route
              index
              element={
                <Suspense fallback={<LoadingFallback />}>
                  <BillingList />
                </Suspense>
              }
            />
            <Route
              element={
                <Suspense fallback={<LoadingFallback />}>
                  <BillingSave />
                </Suspense>
              }
              path="billing-save"
            />
          </Route>
          <Route path="payment-received">
            <Route
              index
              element={
                <Suspense fallback={<LoadingFallback />}>
                  <PaymentList />
                </Suspense>
              }
            />
            <Route
              element={
                <Suspense fallback={<LoadingFallback />}>
                  <PaymentSave />
                </Suspense>
              }
              path="payment-save"
            />
          </Route>
          <Route path="notification">
            <Route
              path="notification-activity"
              element={
                <Suspense fallback={<LoadingFallback />}>
                  <NotificationActivityList />
                </Suspense>
              }
            />
            <Route
              path="upcoming-vaccination"
              element={
                <Suspense fallback={<LoadingFallback />}>
                  <UpComingVaccination />
                </Suspense>
              }
            />
            <Route
              path="upcoming-followup"
              element={
                <Suspense fallback={<LoadingFallback />}>
                  <UpComingFollowUp />
                </Suspense>
              }
            />
            <Route
              path="activity-list"
              element={
                <Suspense fallback={<LoadingFallback />}>
                  <ActivityList />
                </Suspense>
              }
            />
          </Route>
          <Route path="opd-clinical">
            <Route
              index
              element={
                <Suspense fallback={<LoadingFallback />}>
                  <OPDClinical />
                </Suspense>
              }
            />
          </Route>
          <Route path="add-mr">
            <Route
              index
              element={
                <Suspense fallback={<LoadingFallback />}>
                  <OPDClinical />
                </Suspense>
              }
            />
          </Route>
          <Route path="patient-save">
            <Route
              index
              element={
                <Suspense fallback={<LoadingFallback />}>
                  <AddMr />
                </Suspense>
              }
            />
          </Route>
          <Route path="add-appointment">
            <Route
              index
              element={
                <Suspense fallback={<LoadingFallback />}>
                  <AddAppointment />
                </Suspense>
              }
            />
          </Route>
          <Route path="appointments">
            <Route
              index
              element={
                <Suspense fallback={<LoadingFallback />}>
                  <Appointments />
                </Suspense>
              }
            />
          </Route>
          <Route path="patient-history">
            <Route
              index
              element={
                <Suspense fallback={<LoadingFallback />}>
                  <PatientHistory />
                </Suspense>
              }
            />
          </Route>
          <Route path="profile">
            <Route
              index
              element={
                <Suspense fallback={<LoadingFallback />}>
                  <Profile />
                </Suspense>
              }
            />
          </Route>
          <Route path="doctor-schedule">
            <Route
              index
              element={
                <Suspense fallback={<LoadingFallback />}>
                  <DoctorSchedule />
                </Suspense>
              }
            />
          </Route>
          {/* <Route path="outreach-visits">
            <Route
              index
              element={
                <Suspense fallback={<LoadingFallback />}>
                  <OutrichVisits />
                </Suspense>
              }
            />
          </Route> */}
          <Route element={<AuthGuard disallowedRoles={["user"]} />}>
            <Route path="report">
              <Route
                index
                element={
                  <Suspense fallback={<LoadingFallback />}>
                    <Report />
                  </Suspense>
                }
              />
              <Route
                path="bill-summary-by-payment"
                element={
                  <Suspense fallback={<LoadingFallback />}>
                    <BillSummaryByPayment />
                  </Suspense>
                }
              />
              <Route path="bill-summary-by-patient">
                <Route
                  index
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <BillSummaryByPatient />
                    </Suspense>
                  }
                />
                <Route
                  path="bill-summary-by-patient-detail"
                  element={
                    <Suspense fallback={<LoadingFallback />}>
                      <BillSummaryByPatientDetail />
                    </Suspense>
                  }
                />
              </Route>
              <Route
                path="form-3c-form-25-report"
                element={
                  <Suspense fallback={<LoadingFallback />}>
                    <Form3CForm25Report />
                  </Suspense>
                }
              />
              <Route
                path="procedure-status-report"
                element={
                  <Suspense fallback={<LoadingFallback />}>
                    <ProcedureStatusReport />
                  </Suspense>
                }
              />
            </Route>
          </Route>
          <Route path="growth-chart">
            <Route
              index
              element={
                <Suspense fallback={<LoadingFallback />}>
                  <GrowthChartItemList />
                </Suspense>
              }
            />
            <Route
              element={
                <Suspense fallback={<LoadingFallback />}>
                  <GrowthChartItemSave />
                </Suspense>
              }
              path="growth-chart-item-save"
            />
          </Route>
        </Route>
        <Route
          path="terms"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <TermsAndConditions />
            </Suspense>
          }
        />
        <Route
          path="privacy-policy"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <PrivacyAndPolicy />
            </Suspense>
          }
        />
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
